import { cargoReleaseTypes } from './actionTypes';

const INIT_STATE = {
  data: [],
  milestoneConfig: [],
  CountItems: 0,
  isLoading: false,
  error: {},
};

const cargoRelease = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case cargoReleaseTypes.GET_CARGORELEASE:
      return {
        ...state,
        isLoading: true,
      };
    case cargoReleaseTypes.GET_CARGORELEASE_SUCCESS:
      return {
        ...state,
        data: action.payload.cargoReleasesData,
        CountItems: action.payload.CountItems,
        isLoading: false,
      };

    case cargoReleaseTypes.GET_CARGORELEASE_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case cargoReleaseTypes.GET_MILESTONESCONFIG_CR_SUCCESSS:
        return{
          ...state,
          milestoneConfig: action.payload
        }
  
    case cargoReleaseTypes.GET_MILESTONESCONFIG_CR_FAIL:
          return{
            ...state,
            error: action.payload,
          }

    default:
      return state;
  }
};

export default cargoRelease;
